import { render } from "./NewAppLogoSvg.vue?vue&type=template&id=6b490c76&scoped=true"
import script from "./NewAppLogoSvg.vue?vue&type=script&lang=js"
export * from "./NewAppLogoSvg.vue?vue&type=script&lang=js"

import "./NewAppLogoSvg.vue?vue&type=style&index=0&id=6b490c76&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b490c76"]])

export default __exports__